import type { ComponentType } from 'react'
import { useEffect } from 'react'

export const mark = <P,>(Component: ComponentType<P>) =>
  function Marked(props: any) {
    useEffect(() => {
      if (typeof performance?.mark !== 'undefined') {
        performance.mark(Component.displayName ?? Component.name ?? 'unknown')
      }
    }, [])

    return <Component {...props} />
  }
